import { lazy } from "react";

const ActivityDashboardPage = lazy(() => import("./activityDashboard/page"));
const ActivityLogsPage = lazy(() => import("./activityLogs/page"));
const AnalyticsPage = lazy(() => import("./analytics/page"));
const ContentPage = lazy(() => import("./content/page"));
const ConversionsPage = lazy(() => import("./conversions/page"));
const DashboardPage = lazy(() => import("./dashboard/page"));
const GraphPage = lazy(() => import("./graph/page"));
const JourneyPage = lazy(() => import("./journey/page"));
const NotificationsPage = lazy(() => import("./notifications/page"));
const MigrationsPage = lazy(() => import("./migrations/page"));
const FormPage = lazy(() => import("./form/page"));
const UsersPage = lazy(() => import("./users/page"));
const InvitationsPage = lazy(() => import("./invitations/page"));
const FormsPage = lazy(() => import("./forms/page"));
const FormAnswersPage = lazy(() => import("./formAnswers/page"));
const EmailsPage = lazy(() => import("./emails/page"));
const WebhooksPage = lazy(() => import("./webhooks/page"));
const HelpArticlesPage = lazy(() => import("./helpArticles/page"));
const WorkflowsPage = lazy(() => import("./workflows/page"));
const WorkflowExecutionsPage = lazy(
  () => import("./workflows/executions/page")
);

const routes = [
  {
    index: true,
    element: <DashboardPage />,
  },
  {
    path: "notifications",
    element: <NotificationsPage />,
  },
  {
    path: "migrations",
    element: <MigrationsPage />,
  },
  {
    path: "form",
    element: <FormPage />,
  },
  {
    path: "users",
    element: <UsersPage />,
  },
  {
    path: "invitations",
    element: <InvitationsPage />,
  },
  {
    path: "content",
    element: <ContentPage />,
  },
  {
    path: "forms",
    element: <FormsPage />,
  },
  {
    path: "formAnswers",
    element: <FormAnswersPage />,
  },
  {
    path: "emails",
    element: <EmailsPage />,
  },
  {
    path: "webhooks",
    element: <WebhooksPage />,
  },
  {
    path: "helpArticles",
    element: <HelpArticlesPage />,
  },
  {
    path: "activity-dashboard",
    element: <ActivityDashboardPage />,
  },
  {
    path: "activityLogs",
    element: <ActivityLogsPage />,
  },
  {
    path: "analytics",
    element: <AnalyticsPage />,
  },
  {
    path: "conversions",
    element: <ConversionsPage />,
  },
  {
    path: "journey",
    element: <JourneyPage />,
  },
  {
    path: "graph",
    element: <GraphPage />,
  },
  {
    path: "workflows",
    children: [
      { index: true, element: <WorkflowsPage /> },
      { path: "executions", element: <WorkflowExecutionsPage /> },
    ],
  },
];

export default routes;
